import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { ButtonOutline, ButtonRow } from "../components/button.tsx";
import React from "react";
import { ViewBase3Inner } from "../views/view_base_3.tsx";

export default function ModalBase2() {
    const pop_modal = useStore((state)=>state.pop_modal);
    const clear_modal = useStore((state) => state.clear_modal);

   return (<Panel >
            <h1 id="modal-title">Wie heizen Sie aktuell?</h1>
            <ViewBase3Inner/>
            <ButtonRow>
              <ButtonOutline label='zurück' onClick={()=>{
                pop_modal();
              }}/>
              <Button label='weiter' onClick={()=>{
                clear_modal();
              }}/>
            </ButtonRow>
         </Panel>)
}